import { PrincipalAPIService } from "./principal";
import api from "..";

export default new PrincipalAPIService(api);
